/**
 * useRedirectWhenSubscribed
 * Watches the signed-in org's subscription doc and enters the booth the
 * moment it becomes active. Shared by the billing page (covers direct
 * visits by subscribed users and checkout finishing in another tab) and
 * the checkout success page (waits out the Stripe webhook).
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '@/services/firebase';
import { getCurrentUser } from '@/services/auth.service';
import { isActiveSubscription } from '@/utils/subscription';
import { SubscriptionSnapshot } from '@/types';

export function useRedirectWhenSubscribed(): void {
  const navigate = useNavigate();

  useEffect(() => {
    const user = getCurrentUser();
    if (!user) return;

    const subRef = doc(db, 'organizations', user.uid, 'subscription', 'current');
    return onSnapshot(subRef, (snapshot) => {
      if (
        snapshot.exists() &&
        isActiveSubscription(snapshot.data() as SubscriptionSnapshot)
      ) {
        navigate('/booth', { replace: true });
      }
    });
  }, [navigate]);
}
